import { useIntl } from '@/intl'
import { HeadingLabel } from '@/scopes/products/pages/components/HeadingLabel'
import styles from './SkiAncillaries.module.css'
import { SkiLessons } from './SkiLessons'
import { SkiMaterial } from './SkiMaterial'
import { SkiPass } from './SkiPass'

export default function SkiAncillaries() {
  const intl = useIntl()

  return (
    <div>
      <HeadingLabel text={intl.formatMessage({ id: 'ski_ancillaries_section_title' })} />
      <div className={styles.content}>
        <SkiPass />
        <SkiLessons />
        <SkiMaterial />
      </div>
    </div>
  )
}
